import { CalendarClock, Hourglass } from "lucide-react";
import { STYLE_ETAT, TYPES_DATE, fmtJour, relatif } from "@/lib/echeance";

/** Pastille d'échéance d'une instance en cours. */
export function EcheanceBadge({ e, court = false, testId }) {
  if (!e) return null;
  const Icon = e.type === "remise" ? CalendarClock : Hourglass;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ${STYLE_ETAT[e.etat] || STYLE_ETAT.ok}`} data-testid={testId}>
      <Icon size={11} />
      {court ? relatif(e) : `${TYPES_DATE[e.type]?.court} : ${fmtJour(e.date).replace(/\/\d{4}$/, "")} · ${relatif(e)}`}
    </span>
  );
}

/** Choix de la date d'une instance, avec raccourcis. */
export function ChoixDate({ type, value, onChange, raccourcis, min, max, testId }) {
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-1.5">
        {raccourcis.map(([label, iso]) => (
          <button key={label} type="button" onClick={() => onChange(iso)}
            className={`text-xs px-2.5 h-8 rounded-md border ${value === iso ? "border-primary bg-primary/10 text-primary font-semibold" : "border-border hover:bg-accent"}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <input type="date" value={value || ""} min={min} max={max} onChange={(ev) => onChange(ev.target.value)}
          className="h-9 px-3 rounded-md border border-input bg-transparent text-sm" data-testid={testId} />
        {value && <span className="text-sm text-muted-foreground first-letter:uppercase">{fmtJour(value, true)}</span>}
      </div>
      <p className="text-xs text-muted-foreground">
        {type === "remise" ? "Jour où le colis repart en livraison." : "Sans solution à cette date, le colis est retourné à l'expéditeur."}
      </p>
    </div>
  );
}
